import React from "react";
import Reveal from "../Reveal";
import { useContent } from "../../context/ContentContext";

export default function Stats() {
  const { content } = useContent();
  const stats = content.stats || [];
  return (
    <section className="relative -mt-2 pb-4">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="bg-card rounded-2xl border border-white/10 shadow-[0_20px_60px_-30px_rgba(12,97,82,0.25)] grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-border overflow-hidden">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 80} className="p-7 lg:p-8 text-center">
              <p className="font-display text-4xl lg:text-5xl text-[#2ED9B8]">{s.value}</p>
              <p className="mt-2 text-sm text-muted-foreground">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
